const $ = window.jQuery;

const open = url => {
  $.featherlight({
    iframe: url,
    variant: 'featherlight-teamtailor',
  });
};

export default new class {
  constructor() {
    this.selectors = {
      button: '.js-teamtailor-apply',
    };

    $(document).ready(() => {
      if ($.featherlight) {
        this.init();
      }
    });
  }

  init() {
    this.bindButtonClick();
    this.bindApplyLinkClick();
  }

  bindButtonClick() {
    $(document).on('click', this.selectors.button, event => {
      event.preventDefault();
      open($(event.currentTarget).attr('href'));
    });
  }

  // Same-page "#apply" / "#apply-now" links open the job's Teamtailor form
  // instead of jumping to the apply section.
  bindApplyLinkClick() {
    $(document).on('click', 'a[href*="#"]', event => {
      const link = event.currentTarget;

      if (
        link.hostname !== window.location.hostname ||
        link.pathname !== window.location.pathname
      ) {
        return;
      }

      const hash = link.hash
        .slice(1)
        .toLowerCase()
        .replace(/[^a-z]/g, '');

      if (hash !== 'apply' && hash !== 'applynow') {
        return;
      }

      const url = $(this.selectors.button).attr('href');

      if (!url) {
        return;
      }

      event.preventDefault();
      open(url);
    });
  }
}();



// WEBPACK FOOTER //
// ./wp/wp-content/themes/yanmar-chisel/src/scripts/modules/teamtailor-apply.js